import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { DataGridComponent } from "../../components/common/DataGridComponent";
import { useNavigate } from "react-router-dom";
import { useInventoryDetails } from "../../components/Inventory/useInventoryDetails";
import { useGetAllInventoryQuery } from "../../store/services/componentsQuery";

const Inventory: React.FunctionComponent<any> = () => {
  const { rowData } = useInventoryDetails();
  const [columns, setColumns] = useState([]);
  const navigate = useNavigate();
  const { data: getAllData } = useGetAllInventoryQuery({});

  useEffect(() => {
    if (getAllData?.fields && getAllData?.fields.length > 0) {
      setColumns(getAllData?.fields);
    }
  }, [getAllData]);

  const actions = {
    id: (data: any) => {
      navigate(`/inventory/${data?.id}`);
    },
    studyID: (data: any) => {
      //   console.debug(data);
    },
    actionsColumn: {
      action_edit: (data: any) => {
        // console.debug(data)
      },
      action_delete: (data: any) => (data: any) => {
        // console.debug(data)
      },
    },
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography variant="h4" gutterBottom>
            Inventory
          </Typography>
        </Grid>
        <Grid item justifyContent="flex-end">
          &nbsp;
        </Grid>
      </Grid>
      <Box sx={{ width: "100%", height: "calc(100vh - 150px)" }}>
        <DataGridComponent
          columns={columns as any}
          hasDefinedColumns={false}
          rows={rowData ?? []}
          showQuickFilter
          actions={actions}
        />
      </Box>
    </>
  );
};

export default Inventory;
